module.exports = __webpack_public_path__ + "img/logo.bb903df3.svg";